import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Progressbar from 'Pods/Shared/Progressbar'

function ProductAnalyticsTierBar({
  title, currentScore, requiredScore, format,
}) {
  return (
    <div className="tiers-bar-container">
      <div className="tiers-bar__head">
        <div className="tiers-bar__title">{title}</div>
        <div className="tiers-bar__score">{numeral(currentScore).format(format)}/{requiredScore}</div>
      </div>
      <Progressbar
        value={currentScore}
        maxValue={requiredScore}
        labelSize="label-none"
        barColor={currentScore < requiredScore ? 'is-negative' : 'is-dark'}
      />
    </div>
  )
}

ProductAnalyticsTierBar.propTypes= {
  title: PropTypes.string.isRequired,
  currentScore: PropTypes.number.isRequired,
  requiredScore: PropTypes.number.isRequired,
  format: PropTypes.string,
}

ProductAnalyticsTierBar.defaultPropTypes= {
  format: '0',
}

export default ProductAnalyticsTierBar
